"use client";
import React, { useEffect, useRef, useState } from "react";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";

const PublicServiceComp = ({ items }: { items: any[] }) => {
  const scrollAmount = 200;
  const intervalTime = 3000;
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = useState(false);
  const [direction, setDirection] = useState<"left" | "right">("right");

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        if (scrollRef.current) {
          if (direction === "right") {
            scrollRef.current.scrollBy({
              left: scrollAmount,
              behavior: "smooth",
            });
            if (
              scrollRef.current.scrollLeft + scrollRef.current.clientWidth >=
              scrollRef.current.scrollWidth
            ) {
              setDirection("left");
            }
          } else {
            scrollRef.current.scrollBy({
              left: -scrollAmount,
              behavior: "smooth",
            });
            if (scrollRef.current.scrollLeft === 0) {
              setDirection("right");
            }
          }
        }
      }, intervalTime);

      return () => clearInterval(interval);
    }
  }, [isHovered, direction]);

  return (
    <div className="relative w-full">
      <div className="flex justify-between items-center">
        <h2 className="font-semibold text-dark text-xl lg:text-2xl">
          Layanan Publik
        </h2>
        <div
          className="hidden lg:flex lg:items-center lg:gap-2"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <button
            onClick={scrollLeft}
            className="bg-[#daeae2] p-1 rounded-full hover:bg-opacity-45"
          >
            <ArrowLeftIcon className="size-6 text-green" />
          </button>
          <button
            onClick={scrollRight}
            className="bg-[#daeae2] p-1 rounded-full hover:bg-opacity-45"
          >
            <ArrowRightIcon className="size-6 text-green" />
          </button>
        </div>
      </div>
      <div className="title-under-line"></div>

      <div
        ref={scrollRef}
        className="flex overflow-x-scroll scrollbar-hide space-x-4 p-4"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {items.map((item) => (
          <a
            href={item.href}
            key={item.id}
            className="relative flex-shrink-0 p-2 w-32 h-32 bg-white shadow-sm hover:shadow-md text-center rounded-md flex flex-col justify-center items-center"
            target="_blank"
          >
            <img
              src={item.imageSrc}
              className="h-16 object-contain"
              alt={item.name}
            />
            <p className="absolute bottom-2 text-sm text-green font-medium">
              {item.name}
            </p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default PublicServiceComp;
